const translations: any = {
    Search: 'Tìm',
    'Companies Hiring Now': 'Công ty đang tuyển dụng',
    'Most Viewed Companies': 'Công ty xem nhiều nhất',
    'Most Followed Companies': 'Công ty theo dõi nhiều nhất',
    'Featured Companies': 'Công ty nổi bật',
    'Search result for ': 'Kết quả tìm kiếm cho ',
    'Company Search Result': 'Kết Quả Tìm Kiếm',
    'No results found': 'Không có kết quả',
    'There is no company matches with your search': 'Từ khoá tìm kiếm của bạn không khớp với tên công ty nào',
    'We found': 'Chúng tôi tìm thấy',
    'companies matching with': 'công ty phù hợp với',
    'company matching with': 'công ty phù hợp với',
    'category': 'ngành',
    'categories': 'ngành',
    'View more': 'Xem thêm',
    'Searching': 'Đang tìm',
    'Clear keyword': 'Xoá từ khoá'
}

export default translations
